
import { u_ } from "@pressmedia/webappbase";

/**
 * 指定した配列データを元にリスト（DOM）を更新する関数
 *
 * @param {Array} [list]
 * @returns Promise
 */
async function initList(list) {
	// [check]
	if(!this.module) {
		return Promise.reject({
			code: NaN,
			messages: [`${this.name} has no module.`],
			method: "initList"
		});
	}
	
	if( !u_.isObject(this.module.config.dataParams) ) {
		return Promise.reject({
			code: NaN,
			messages: ["module.loadConfig is not executed yet."],
			method: "initList"
		});
	}
	
	// [for wysiwyg]
	if(this.module.wysiwygParams.length) {
		// ※同一パスは重複読み込みしないので、initListの度に呼び出しても問題ない
		this.module.wysiwyg.importPluginStyleSheet(
			this.module.app,
			this.$self.get(0).ownerDocument
		);
	}
	
	// [execute]
	this.$self.removeClass("has-none");
	
	const args = await Promise.all([
		// [内包するreplicantをrendering状態に変更]
		!this.infinite && new Promise((resolve, reject) => {
			this.$self.removeClass("all-sleeping");
			this._startRenderingReplicants(err => !err ? resolve() : reject(err));
		}),
		
		// [生成するソースの受け渡し]
		new Promise((resolve, reject) => {
			this._getSource(list, (err, itemList, total, offset, response) => {
				if(err) {
					reject(err);
				} else {
					resolve({ itemList, total, offset, response });
				}
			});
		})
	]);
	
	const { itemList, total, offset, response } = args[1];
	
	// [replicantsが不足している場合は追加する]
	const itemCount = itemList.length;
	const	newReplicants = this.infinite ? itemCount : itemCount - this.getReplicants().length;
	
	await Promise.all([
		// 不足分を追加
		(newReplicants > 0) && this.addReplicants(newReplicants, {
			onReady($self) {
				return this.setState("is", "rendering");
			}
		}),
		
		// 最低でもminimumRenderingTimeミリ秒待つ
		new Promise(resolve => setTimeout(resolve, this.minimumRenderingTime))
	]);
	
	let replicants = this.getReplicants();
	this.infinite && ( replicants = replicants.slice(itemCount * -1) );
	
	// [replicantの更新]
	const methods = replicants.map((vuw, i) => {
		const state = {};
		if( u_.isObject(itemList[i]) ) {
			state.item = itemList[i];
		} else {
			state.is = "sleeping";
		}
		return vuw.setState(state).then(() => vuw.getImageLoadPromise());
	});
	
	// [pagerの更新]
	this.showPager && methods.push( this.updPager(offset, itemCount, total) );
	
	await Promise.all(methods);
	
	!replicants.length && this.$self.addClass("has-none");
	!itemList.length && this.$self.addClass("all-sleeping");
	
	return response;
}

export default initList;
